<template>
    <div class="p-[15px] rounded-[10px] bg-[#F1F1F1]/50">
        <div class="mobile:block tablet:flex tablet:gap-[20px] justify-between mb-[10px] tablet:mb-[20px]">
            <!-- {{ plan }} -->
            <div class="w-full tablet:w-4/6 tablet:mt-[5px]">
                <div class="flex items-start justify-between">
                    <div class="flex flex-wrap items-center laptop:items-start largeDesktop:items-center gap-[7px]">
                        <h6
                            class="m-0 font-lato text-[12px] rounded-full px-[10px] py-[2px] inline-block w-max shadow-[0_0_4px_0_#00000026] text-[#fff] bg-customBlue-100">
                            {{ plan?.trade_name ?? '' }} </h6>
                        <span v-if="plan.is_single_plan_bundle == 1"
                            class="font-roboto font-normal text-[12px] text-customYellow-100">Optional
                            Coverage</span>
                    </div>
                    <div
                        class="font-roboto mobile:mt-0 tablet:mt-[10px] mobile:flex flex-col justify-end tablet:hidden text-left">
                        <p class="m-0 w-max text-sm font-medium text-[#999999]">{{ plan.months }}
                            months
                            plan
                        </p>
                        <h4 class="m-0 text-lg font-roboto font-bold text-[#333333]">
                            ${{ $helper.formatAmount(plan.months) }}/mo</h4>
                    </div>
                </div>
                <div class="flex items-center gap-[10px] mb-[5px] tablet:mt-[5px]">
                    <img src="../../assets/images/check-double-purple.png" alt="Check Icon" class="w-[16px] h-[16px]">
                    <span class="text-[14px] font-roboto font-normal text-[#333]">{{ plan.plan_name }}</span>
                </div>
                <p class="m-0 text-[12px] font-roboto font-normal text-[#666]">{{ plan.description }}</p>
            </div>
            <div class="mobile:hidden tablet:flex justify-end w-2/6">
                <div class="max-w-max text-left">
                    <p class="m-0 text-[16px] font-medium font-roboto text-[#999999]">{{ plan.months }} months plan</p>
                    <h4 class="m-0 text-[20px] font-roboto font-bold text-[#333333]">
                        ${{ $helper.formatAmount(plan.item_unit_price) }}/mo</h4>
                </div>
            </div>
        </div>
        <div class="flex items-center gap-[10px]">
            <div class="w-max laptop:w-full mobile:flex mobile:justify-between mobile:items-center mobile:w-full ">
                <quantityCounter v-if="plan.is_show_quantity == 1" :quantity="plan.item_quantity"
                    @update-counter="updateCounter" />
                <button v-else type="button" @click="updateCounter('remove')"
                    class="group h-10 w-10 flex items-center justify-center rounded-full focus:outline-0 transition-all border-1 border-[#FE5000] hover:bg-[#FE5000]">
                    <img src="../../assets/images/trash-icon-updated.png" alt="Cart Icon"
                        class="mobile:!w-5 mobile: h-5 tablet:w-7 tablet:h-7 group-hover:hidden object-contain">
                    <img src="../../assets/images/trash-icon-white-updated.png" alt="Cart Icon"
                        class="mobile:!w-5 mobile:!h-5 tablet:w-7 tablet:h-7 hidden group-hover:!block">
                </button>
                <h2 v-if="plan.item_quantity > 1" class="m-0 text-[20px] font-bold font-roboto text-customBlue-100">${{
                    $helper.formatAmount(plan.item_unit_price * plan.item_quantity) }}/mo
                </h2>
            </div>
            <div v-if="showViewDetail"
                class="group cursor-pointer w-[35px] h-[35px] flex items-start justify-center rounded-full shadow-[0_0_4px_0_#00000026] p-[5px] ttransition duration-300 bg-[#fff] hover:bg-[#7695FF]">
                <img src="../../assets/images/eye-purple-icon.svg" alt="" class="w-full h-full group-hover:hidden">
                <img src="../../assets/images/eye-white-icon.svg" alt="" class="w-full h-full hidden group-hover:block">
            </div>
        </div>
    </div>
</template>


<script>
import quantityCounter from '../partialComponent/quantityCounter.vue';
import { mapActions, mapGetters } from "vuex";

export default {
    components: {
        quantityCounter,

    },
    props: {
        plan: Object,
        isSelected: Boolean,
        updateCart: Function,
        updateCard: Object,
        showViewDetail: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            localObject: null
        }
    },

    computed: {
        ...mapGetters([
            "selectedProtectionPlan",
        ]),
    },

    watch: {
        updateCard: function (data) {
            if (data && this.localObject) {
                this.plan.quantity = this.localObject.quantity
            }
            // this.localObject = null
        },



        selectedProtectionPlan: function (data) {

        },

    },

    methods: {
        updateCounter(option, data) {

            this.localObject = JSON.parse(JSON.stringify(this.plan))

            if ((option == "decrement" || option == "remove")&& this.localObject.item_quantity == 1) {
                this.$dialog.show({
                    title: "Delete Item",
                    text: `
                    <div class="flex flex-col items-center justify-center gap-4 text-gray-700 text-[16px]">
                        <img src=${require('../../assets/images/delete-icon-with-bg.png')} style="width:60px; height:auto;">
                        Are you sure you want to delete this item?
                    </div>`,
                    html: true,
                    onConfirm: () => {
                        this.localObject.item_quantity = 0
                        if (this.plan.is_single_plan_bundle ?? 0 == 1) {
                            this.updateCart(option, {
                                id: this.localObject.bundle_id,
                                quantity: this.localObject.item_quantity,
                                partner_id: this.localObject.partner_id
                            }, 'bundle')
                        }
                        else {
                            this.updateCart(option, {
                                id: this.localObject.plan_id,
                                quantity: this.localObject.item_quantity,
                                partner_id: this.localObject.partner_id
                            }, 'plan')
                        }
                    },
                });
            } else {

                if (option == "increment") {
                    this.localObject.item_quantity++
                } else if (option == "decrement") {
                    if (this.localObject.item_quantity > 1) {
                        this.localObject.item_quantity--
                    } else {
                        this.localObject.item_quantity = 0
                    }
                } else {
                    this.localObject.item_quantity = 0
                }

                if (this.plan.is_single_plan_bundle ?? 0 == 1) {
                    this.updateCart(option, {
                        id: this.localObject.bundle_id,
                        quantity: this.localObject.item_quantity,
                        partner_id: this.localObject.partner_id
                    }, 'bundle')
                }
                else {
                    this.updateCart(option, {
                        id: this.localObject.plan_id,
                        quantity: this.localObject.item_quantity,
                        partner_id: this.localObject.partner_id
                    }, 'plan')
                }
            }

        },
    }
}
</script>